import { Injectable, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { SCVService } from './scv.service';
import { ToastService } from './toast.sevice';
import { TranslateService } from './../../../node_modules/@ngx-translate/core';

@Injectable({
    providedIn: 'root'
  })
export class TokenService implements CanActivate{
    
    constructor(private toast:ToastService, public translate:TranslateService, private router: Router,private activatedRoute: ActivatedRoute,
        private scvService: SCVService){}

    async canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot){
        let token : string;
       _.forEach(next.queryParams,(value,key)=>{
           if(key == 'token')  token = value;
       })
       await this.validateToken(token, false);

       if ('500' == this.scvService.getStatus()) {
            this.router.navigateByUrl("error/500");
       }
       else if('404' ==this.scvService.getStatus()) {
        this.router.navigateByUrl("error/404")
      }
       else if(!this.scvService.IsAuthenticated()) {
           this.router.navigateByUrl("error/498")
       } else{
        let interval = setInterval(()=>{
            if(!this.scvService.IsAuthenticated())
                clearInterval(interval)
            else
                this.validateToken(token,true);          
         },60000);
        }   
        return true;
    }

    async validateToken(token: string, isLangSelected: boolean){
        await this.scvService.validateToken(token).toPromise().then((f)=>{
            this.scvService.setApplicationName(f.applicationName);
            this.scvService.setCustomerAttachmentId(f.customerAttachmentId);
            this.scvService.setIsAuthenticated(true);
            this.scvService.setUploadSessionId(f.uploadSessionId);
            this.scvService.setBrandCode(f.brand);
            this.scvService.setCountry(f.country);
            this.scvService.setCustomerConsent(f.customerConsent);
            this.scvService.setLanguage(f.language);
            if (!isLangSelected)
            this.translate.setDefaultLang(f.language);
        },(error)=>{
            if (error.status == 0) {
                this.toast.Error("Service Unavailable");
            } 
            else 
                this.scvService.setIsAuthenticated(false);
         
                this.scvService.setStatus(error.status)
            
            if (error.error.language === undefined)
               this.translate.setDefaultLang('en');
            else 
               this.translate.setDefaultLang(error.error.language);
        })
    }
}